export default {
  getVendedor({ vendedor }) {
    return vendedor
  },

  getEmpresa({ empresa }) {
    return empresa
  },

  getGrupo({ grupo }) {
    return grupo
  },

  getMidia({ midia }) {
    return midia
  }
}
